import { requestGet } from '../utils/request';

const BASE_URL = '/api/seed-advisor/v3/crops';

export function requestCropList() {
  return requestGet(BASE_URL, {
    useMocks: true,
    mockFile: 'crops/default',
  });
}
